import React, {useEffect, useState, useCallback} from 'react'
import {DndProvider, useDrag, useDrop} from 'react-dnd'
import {HTML5Backend} from 'react-dnd-html5-backend'
import clsx from 'clsx'

const ItemTypes = {
  CARD: 'card',
}

interface Item {
  id: string
  title: string
  tipo: string
  name: string
}

const initialItemsA: Item[] = [
  {id: '1', title: 'Estado de Cama', tipo: 'EDC', name: 'beds'},
  {id: '2', title: 'Lotización', tipo: 'LOT', name: 'lots'},
  {id: '3', title: 'Categoría de Habitación', tipo: 'CTH', name: 'categories'},
  {id: '4', title: 'Nuevo estado de camas', tipo: 'ENC', name: 'newBeds'},
]

const initialItemsB: Item[] = []

const DraggableItem = ({item, onDrop, index, moveItem}: any) => {
  const [{isDragging}, dragRef] = useDrag({
    type: ItemTypes.CARD,
    item: {id: item?.id, index},
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const [, dropRef] = useDrop({
    accept: ItemTypes.CARD,
    hover: (draggedItem: any) => {
      if (draggedItem.index !== index) {
        moveItem(draggedItem.index, index)
        draggedItem.index = index
      }
    },
  })

  return (
    <div
      ref={(node) => dragRef(dropRef(node))}
      className={clsx('item', {'opacity-50': isDragging})}
      style={{
        padding: '10px',
        margin: '5px',
        backgroundColor: '#fff',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        cursor: 'move',
      }}
    >
      <span>{item.title}</span>
    </div>
  )
}

const DropContainer = ({children, onDrop}: any) => {
  const [, dropRef] = useDrop({
    accept: ItemTypes.CARD,
    drop: (item: any) => onDrop(item.id),
  })

  return (
    <div
      ref={dropRef}
      className='d-flex flex-column justify-content-center'
      style={{
        minHeight: '150px',
        padding: '10px',
        backgroundColor: '#f4f4f9',
        borderRadius: '8px',
        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)',
      }}
    >
      {children}
    </div>
  )
}

const TotalComponent = ({setDataGroup, setIsReset, isReset}: any) => {
  const [itemsA, setItemsA] = useState<Item[]>(initialItemsA)
  const [itemsB, setItemsB] = useState<Item[]>(initialItemsB)

  useEffect(() => {
    if (isReset) {
      setIsReset(false)
      setItemsA(initialItemsA)
      setItemsB(initialItemsB)
    }
  }, [isReset, setIsReset])

  useEffect(() => {
    setDataGroup(itemsB)
  }, [itemsB, setDataGroup])

  const handleDropToB = useCallback(
    (id: string) => {
      const movedItem = itemsA.find((item) => item?.id === id)
      if (movedItem) {
        setItemsA(itemsA.filter((i) => i?.id !== id))
        setItemsB([...itemsB, movedItem])
      }
    },
    [itemsA, itemsB],
  )

  const handleDropToA = useCallback(
    (id: string) => {
      const movedItem = itemsB.find((item) => item?.id === id)
      if (movedItem) {
        setItemsB(itemsB.filter((i) => i?.id !== id))
        setItemsA([...itemsA, movedItem])
      }
    },
    [itemsA, itemsB],
  )

  const moveItemInA = useCallback(
    (fromIndex: number, toIndex: number) => {
      const updatedItems = [...itemsA]
      const [movedItem] = updatedItems.splice(fromIndex, 1)
      updatedItems.splice(toIndex, 0, movedItem)
      setItemsA(updatedItems)
    },
    [itemsA],
  )

  const moveItemInB = useCallback(
    (fromIndex: number, toIndex: number) => {
      const updatedItems = [...itemsB]
      const [movedItem] = updatedItems.splice(fromIndex, 1)
      updatedItems.splice(toIndex, 0, movedItem)
      setItemsB(updatedItems)
    },
    [itemsB],
  )

  return (
    <DndProvider backend={HTML5Backend}>
      <div className='row py-4 '>
        <div className='col-lg-4 py-9'>
          <h5 className='mb-3 text-center'>Agrupaciones Existentes</h5>
          <DropContainer onDrop={handleDropToA}>
            {itemsA.map((item, index) => (
              item?.id && <DraggableItem key={item.id} item={item} index={index} moveItem={moveItemInA} />
            ))}
          </DropContainer>
        </div>

        <div className='col-lg-4 py-9'>
          <h5 className='mb-3 text-center'>Agrupaciones Seleccionadas</h5>
          <DropContainer onDrop={handleDropToB}>
            {itemsB.map((item, index) => (
              item?.id && <DraggableItem key={item.id} item={item} index={index} moveItem={moveItemInB} />
            ))}
          </DropContainer>
        </div>
      </div>
    </DndProvider>
  )
}

export {TotalComponent}
